import { NavigationClickEventProperties } from '@segment/analytics-next'
import { AnalyticsTrackEvent } from '@/types'

export const createNavigationClickEvent = ({
  menu_type,
  text,
  url,
  section,
  image_url,
}: NavigationClickEventProperties): Extract<AnalyticsTrackEvent, { object: 'Navigation'; action: 'Clicked' }> => {
  const eventProperties: NavigationClickEventProperties = {
    menu_type,
    text,
    url,
    section,
    image_url,
  }

  return {
    object: 'Navigation',
    action: 'Clicked',
    properties: eventProperties,
  }
}
